import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { createServices } from './app/services';
import { config } from './config';
import '@antreja/ui/brand.css';
import './styles.css';
import { SURFACE } from './lib/surface';

if (SURFACE === 'admin') document.title = 'Antreja admin';

const services = createServices(config);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App services={services} />
  </StrictMode>,
);
